const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const plantasService = {
  // Obtener todas las plantas
  getAll: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/plantas`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener plantas:', error);
      throw error;
    }
  },

  // Obtener una planta por ID
  getById: async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/plantas/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al obtener planta:', error);
      throw error;
    }
  },

  // Crear una nueva planta
  create: async (plantaData) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/plantas`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(plantaData),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al crear planta:', error);
      throw error;
    }
  },

  // Actualizar una planta
  update: async (id, plantaData) => {
    try {
      const token = localStorage.getItem('token');
      const updateData = { ...plantaData, id };
      const response = await fetch(`${API_URL}/plantas/update`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al actualizar planta:', error);
      throw error;
    }
  },

  // Eliminar una planta
  delete: async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/plantas/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error al eliminar planta:', error);
      throw error;
    }
  },
};
